/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface DeleteAdministrationRemoteAccessToSite$Params {
  organizationSiteKey: KeyType;
  targetOrganizationSiteKey: KeyType;
}

export function deleteAdministrationRemoteAccessToSite(http: HttpClient, rootUrl: string, params: DeleteAdministrationRemoteAccessToSite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAdministrationRemoteAccessToSite.PATH, 'delete');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('targetOrganizationSiteKey', params.targetOrganizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAdministrationRemoteAccessToSite.PATH = '/administration/organization-sites/{organizationSiteKey}/remote-accesses/{targetOrganizationSiteKey}';
